import { useEffect } from "react";
import { useAudioRecorder } from "../../custom-hooks/useAudioRecorder";
import { useSelector } from "react-redux";
// import { counterUpdater } from "../../redux/features/timer/timerActions";
import { logAudioDetection } from "../../redux/features/audioDetection/audioActions";
import {
  soundDetectionAndRecording,
  voiceDetection,
} from "../../redux/features/audioDetection/audioActions";
import logTypes from "../../redux/features/logTypes";
import { useDispatch } from "react-redux";

const Recorder = () => {
  const isAudioRecording = useSelector((state) => state.audio.isAudioRecording);
  const examStarted = useSelector((state) => state.timer.examStarted);
  const [data, err] = useAudioRecorder({
    isRecording: isAudioRecording && examStarted,
  });
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(counterUpdater());
  // }, [dispatch]);

  useEffect(() => {
    if (examStarted) {
      dispatch(soundDetectionAndRecording());
      dispatch(voiceDetection());
      console.log("sound detection started");
    }
  }, [dispatch, examStarted]);

  useEffect(() => {
    if (err) {
      console.error("error initiating recorder", err);
    }
  }, [err]);

  useEffect(() => {
    if (data) {
      const options = {
        type: "audio/ogg",
      };
      //blob to send to the backend
      const blob = new Blob(data, options);
      dispatch(logAudioDetection(logTypes.SOUND_DETECTED, blob));
    }
  }, [data, dispatch]);

  return null;
};

export default Recorder;
